<mat-dialog-content class="p-0">
  <div class="dialog">
    <p class="text-end">
      <span (click)="dialogRef.close()">
        <svg xmlns="http://www.w3.org/2000/svg" width="13.998" height="13.998" viewBox="0 0 13.998 13.998">
          <path id="close-btn"
            d="M8.177-11.911,6.768-13.32l-5.59,5.59-5.59-5.59L-5.82-11.911l5.59,5.59L-5.82-.732-4.411.677l5.59-5.59L6.768.677,8.177-.732l-5.59-5.59Z"
            transform="translate(5.82 13.32)" fill="#bbb" />
        </svg>
      </span>
    </p>
    <div class="suspend">
      <ng-container>

        <svg xmlns="http://www.w3.org/2000/svg" width="160" height="170" viewBox="0 0 160 170">
          <g id="empty-wallet-ic" transform="translate(-907 -307)">
            <ellipse id="circle" cx="80" cy="79.854" rx="80" ry="79.854" transform="translate(907 317.292)"
              fill="#fdeee7" />
            <path id="Subtraction_3" data-name="Subtraction 3"
              d="M15389.9,15877.723a2.99,2.99,0,0,1-2.287-1.061,2.957,2.957,0,0,1,.366-4.177l7.553-6.317a3,3,0,0,1,4.205.367,2.967,2.967,0,0,1-.367,4.177l-7.553,6.316A2.958,2.958,0,0,1,15389.9,15877.723Zm-40.373,0a2.939,2.939,0,0,1-1.913-.694l-7.553-6.316a2.96,2.96,0,0,1-.371-4.177,3,3,0,0,1,4.205-.367l7.553,6.317a2.957,2.957,0,0,1,.366,4.177A2.978,2.978,0,0,1,15349.531,15877.723Zm20.187-8.964a2.977,2.977,0,0,1-2.981-2.965v-9.829a2.981,2.981,0,0,1,5.963,0v9.829A2.977,2.977,0,0,1,15369.718,15868.759Z"
              transform="translate(-14390.444 -15546)" fill="#f08a56" />
            <g id="empty-wallet-ic-2" data-name="empty-wallet-ic" transform="translate(921.812 304.222)">
              <path id="Subtraction_2" data-name="Subtraction 2"
                d="M14525.123,15650.728h-94.071a15.273,15.273,0,0,1-15.363-15.147v-72.654a15.273,15.273,0,0,1,15.363-15.147h85.893a11.2,11.2,0,0,1,11.271,11.109v13.509l.672.236a11.147,11.147,0,0,1,7.507,10.473v12.842h5.091a3.068,3.068,0,0,1,3.092,3.036v24.219a3.068,3.068,0,0,1-3.092,3.036h-5.091v13.376A11.205,11.205,0,0,1,14525.123,15650.728Zm-103.256-75.559h0v60.41a9.14,9.14,0,0,0,9.185,9.074h94.071a5.072,5.072,0,0,0,5.091-5.04v-13.376h-1a1.14,1.14,0,0,1-.253-.021,36.015,36.015,0,0,0-3.986-.266c-7.266-.307-9.017-.607-9.432-.723l-12.154-11.993a3,3,0,0,1,0-4.285l12.272-12.107a3.135,3.135,0,0,1,2.188-.9h12.362v-12.842a5.069,5.069,0,0,0-5.091-5.036h-94.087a15.414,15.414,0,0,1-7.668-2.039l-1.5-.86Zm97.269,26.851h0l-9.192,9.07,9.192,9.074h19.256v-18.145h-19.257Zm-88.084-48.168a9.073,9.073,0,1,0,0,18.145h90.983v-13.108a5.069,5.069,0,0,0-5.091-5.036Z"
                transform="translate(-14414.5 -15506.327)" fill="#e9580e" />
              <g id="Group_10974" data-name="Group 10974" transform="translate(-96.74 -54.544)">
                <path id="Path_18273" data-name="Path 18273"
                  d="M182.595,234.275a3.906,3.906,0,0,0,5.521-5.525,12.8,12.8,0,0,0-18.071,0,3.905,3.905,0,0,0,5.521,5.525,4.977,4.977,0,0,1,7.028,0Z"
                  transform="translate(-29.71 -60.149)" fill="#f08a56" />
                <path id="Path_18274" data-name="Path 18274"
                  d="M261.171,155.759a3.906,3.906,0,0,0,3.905-3.905V147.67a3.906,3.906,0,0,0-7.811,0v4.183A3.905,3.905,0,0,0,261.171,155.759Z"
                  transform="translate(-95.068 -0.07)" fill="#f08a56" />
                <path id="Path_18275" data-name="Path 18275"
                  d="M132.638,143.694a3.906,3.906,0,0,0-3.905,3.905v4.183a3.905,3.905,0,0,0,7.811,0V147.6A3.906,3.906,0,0,0,132.638,143.694Z"
                  fill="#f08a56" />
              </g>
            </g>
          </g>
        </svg>


        <h4 class="title mt-4">{{'bidders.Not enough fund' | translate}}</h4>
        <ng-container *ngIf="data?.type=='join'; else elseTemplate">
          <div class="hint">
            {{'bidders.must-add-funds-to-wallet_join' | translate}}
          </div>
        </ng-container>
        <ng-template #elseTemplate>
          <div class="hint">
            {{'bidders.must-add-funds-to-wallet_bid' | translate}}
          </div>
        </ng-template>




        <div class="you-balance" *ngIf="data">
          <div class="increase-last-bid">
            <p class="txt mb-2">{{"Auction Item.Current wallet balance"|translate}}</p>
            <p class="price">{{"Auction Item.SR"|translate}} <b>{{ data.current_balance |number}}</b></p>
          </div>
          <div class="current-balance">
            <p class="txt mb-2">{{"Auction Item.Auction starting bid"|translate}}</p>
            <p class="price">{{"Auction Item.SR"|translate}} <b>{{data.price | number}}</b></p>
          </div>
        </div>




      </ng-container>

    </div>
  </div>
</mat-dialog-content>
 <mat-dialog-actions align="center">

  <div class="actions-join mt-2">
    <button mat-button (click)="dialogRef.close()" class="btnLight_fill me-3">
      {{"Auction Item.Cancel"|translate}}
    </button>
    <button (click)="confirm()" mat-button class="btn_fill" type="submit">
      {{'bidders.Top-up my wallet' | translate}}
    </button>
  </div>
</mat-dialog-actions>